<template>
    <div class="container">
        <div class="nav_header">
            <h2>我购买的店铺</h2>
        </div>

        <div v-loading="loading">
            <el-table v-loading="loading" :data="data_source" align="center">
                <el-table-column prop="resource_id" label="店铺编号" width="110"> </el-table-column>
                <el-table-column prop="name" label="店铺名称">
                    <div slot-scope="scope">
                        {{ scope.row.title }}
                    </div>
                </el-table-column>

                <el-table-column prop="order.order_no" label="订单号" width="120"></el-table-column>

                <el-table-column prop="price" label="价格/元" width="100">
                    <div slot-scope="scope">
                        {{ wan(scope.row.order.amount) }}
                    </div>
                </el-table-column>
                <el-table-column prop="order.created_at" label="购买时间" width="150">
                    <div slot-scope="scope">{{ scope.row.order.created_at | dateformat("YYYY-MM-DD HH:mm") }}</div>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination
            style="text-align:center;margin-top:24px;"
            background
            layout="total,prev, pager, next"
            :total="pagination.total"
            :current-page="pagination.current_page"
            :page-size="pagination.per_page"
            @size-change="handle_size_change"
            @current-change="handle_current_change"
        >
        </el-pagination>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        data() {
            return {
                data_source: [],
                loading: false,
                object: "",
                dateBetween: "",
                picker_options: {
                    shortcuts: [
                        {
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit("pick", [start, end]);
                            },
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit("pick", [start, end]);
                            },
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit("pick", [start, end]);
                            },
                        },
                    ],
                },
                pagination: {
                    total: 0,
                    per_page: 20,
                    current_page: 1,
                },
            };
        },
        created() {
            this.load();
            this.reset_query();
        },
        watch: {
            $route() {
                this.load();
                this.parse_query();
            },
        },
        methods: {
            load() {
                this.loading = true;
                this.$http
                    .get("/resource/buyer/purchased?" + this.objectToQuery(this.$route.query))
                    .then((response) => {
                        if (response.success) {
                            this.data_source = response.data;
                            this.pagination = response.pagination;
                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false;
                    });
            },
            parse_query() {
                const query = this.$route.query;
                this.dateBetween = query["paid_at"] ? query["paid_at"].split(",") : "";
            },
            on_delete(record) {
                window.open(record.viewpdf_url);
            },
            on_down(record) {
                window.open(record.download_url);
            },
        },
    };
</script>

<style scoped>
    .card-slim {
        max-height: 400px;
    }

    .show-more {
        height: 100px;
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
        background: linear-gradient(#ffffffa8, white);
    }
</style>
